import React, { Component } from 'react';
import classNames from 'classnames';

import './styles.css';

/**
 * A simple section with variable padding.
 *
 * @typedef {Object} Props
 * @prop {String} [className]
 * @prop {*} [forwardedRef]
 * @prop {Object} [style]
 *
 * @augments {Component<Props>}
 */
export default class PaddedSection extends Component {

	genClassName = (props) => classNames('PaddedSection', props.className);

	render () {
		const { children, forwardedRef, style } = this.props;

		return (
			<section
				className={this.genClassName(this.props)}
				ref={forwardedRef}
				style={style}
			>
				{children}
			</section>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/PaddedSection/PaddedSection.js